import { COOKIE_CONSENT_COOKIE, hasFunctionalCookieConsent } from "shared/CookieConsent";
import { FIRST_PARTY_COOKIES } from "shared/SharedConstants";

/** The UI libraries that front-end docs examples are shown in. */
export const DOCS_UI_LIBRARIES = ["react", "vue", "svelte", "html"] as const;
export type DocsUiLibrary = (typeof DOCS_UI_LIBRARIES)[number];

export const parseDocsUiLibrary = (value: string | null | undefined): DocsUiLibrary =>
  DOCS_UI_LIBRARIES.includes(value as DocsUiLibrary) ? (value as DocsUiLibrary) : "react";

/**
 * The UI library docs and blog pages render on the server: the saved choice, kept only with
 * functional cookie consent, like the SDK language (src/lib/DocsLanguage.ts). The edge cache keys
 * those pages on the same value (src/lib/CFCache.ts).
 */
export const getSavedDocsUiLibrary = (getCookie: (name: string) => string | undefined) =>
  parseDocsUiLibrary(
    hasFunctionalCookieConsent(getCookie(COOKIE_CONSENT_COOKIE.name))
      ? getCookie(FIRST_PARTY_COOKIES.DOCS_UI_LIBRARY.name)
      : undefined,
  );

/** The highlighting language for code under each UI library tab. */
export const DOCS_UI_LIBRARY_SYNTAX: Record<DocsUiLibrary, string> = {
  react: "tsx",
  vue: "vue",
  svelte: "svelte",
  html: "javascript",
};

/** Library names for exports without translation, such as the Markdown export. */
export const DOCS_UI_LIBRARY_NAMES: Record<DocsUiLibrary, string> = {
  react: "React",
  vue: "Vue",
  svelte: "Svelte",
  html: "Plain JavaScript",
};
